import React from "react";

const ImageModal = ({ imageUrl, onClose }) => {
  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white/30 backdrop-blur-lg p-4 rounded-lg relative max-w-4xl w-full max-h-[95vh] overflow-hidden">
        <button 
          onClick={onClose} 
          className="absolute top-2 right-2 text-white bg-red-500 rounded-full p-2"
        >
          X
        </button>
        <div className="flex justify-center items-center">
          <img 
            src={imageUrl} 
            alt="Preview" 
            className="max-w-full max-h-full object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
